



























































import { Component, Mixins, Inject } from "vue-property-decorator";
import { ILeadForm } from "@/models/leads";
import HasValidation from "@/mixins/HasValidation";
import RequestPromises from "@/mixins/requestPromises";
import {
  ILeadProviderData,
  ILeadProviderMethods
} from "@/models/providers/lead";

@Component({
  components: {
    "lead-notes": () => import("@/components/app/admin/leads/leadNotes.vue"),
    "lead-form": () => import("@/components/app/admin/leads/leadForm.vue"),
    "related-leads-table": () =>
      import("@/components/app/admin/leads/relatedLeadsTable.vue")
  }
})
export default class AdminLeadOverview extends Mixins(
  RequestPromises,
  HasValidation
) {
  // Inject

  @Inject({ from: "leadProvider" })
  public readonly $leadProvider!: () => ILeadProviderData;

  @Inject({ from: "leadMethods" })
  public readonly $leadMethods!: ILeadProviderMethods;

  // Data

  public form: ILeadForm = {
    name: "",
    email: "",
    brand_id: "",
    notifications_disabled: false
  };

  public initialForm: ILeadForm = {
    name: "",
    email: "",
    brand_id: "",
    notifications_disabled: false
  };

  public isProcessing = false;

  // Computed

  public get $leadData() {
    return this.$leadProvider();
  }

  public get lead() {
    return this.$leadData.lead;
  }

  public get isFormChanged() {
    return !this.$_.isEqual(this.form, this.initialForm);
  }

  public get isConverted() {
    return !!this.lead.assigned_client_at;
  }

  // Life-cycle methods

  public created() {
    if (this.lead.is_main) return this.initForm();
    this.$nextTick(this.redirectToMain);
  }

  // Methods

  public initForm() {
    this.form.name = this.lead.name;
    this.form.email = this.lead.email;
    this.form.brand_id = this.lead.brand_id;
    this.form.notifications_disabled = this.lead.notifications_disabled;
    this.initialForm = this.$_.cloneDeep(this.form);
  }

  public redirectToMain() {
    const mainLead = this.$_.find(this.lead.related_leads, ["is_main", true]);
    if (mainLead === undefined) {
      this.$buefy.toast.open({
        message: this.$t("_.main_lead_not_found") as string,
        type: "is-danger"
      });
      return this.$router.replace({
        name: "adminLeadsList"
      });
    }
    this.$router.replace({
      name: "adminLead",
      params: {
        leadId: mainLead.id
      }
    });
  }

  public revertToInitialState() {
    this.form = this.$_.cloneDeep(this.initialForm);
  }

  public async validateBeforeSubmit() {
    if (!this.$leadData.canUpdateLead) return;
    this.isProcessing = true;
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");
      await this.$leadMethods.updateLead(this.form);
      this.initialForm = this.$_.cloneDeep(this.form);
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
